export default {"src":"/_next/static/media/CredlixLogo.3e80024d.svg","height":60,"width":211};